import React, { FunctionComponent } from 'react'
import { GestureResponderEvent } from 'react-native'

import { values } from 'lodash-es'

import { PersistFormTemplate } from './PersistFormTemplate'
import { tID } from '../../../utils'

/**
 * Contains the forms for persistent store key
 */
export const PersistStoreForm: FunctionComponent<PersistStoreFormProps> = ({
  persistItems,
  onPersistStoreClearKeys,
  onPersistStoreClearAll,
  persistStoreKeys,
}) => {
  const persistStoreFormValues = values(persistStoreKeys).reduce((acc, curr) => {
    const rawValue = persistItems[curr]
    // Stringify objects so they can be displayed in Text components
    const displayValue = typeof rawValue === 'object' && rawValue !== null ? JSON.stringify(rawValue) : String(rawValue)

    acc[curr] = {
      label: curr,
      currentValue: displayValue,
    }
    return acc
  }, {})

  return (
    <PersistFormTemplate
      values={persistStoreFormValues}
      onSubmit={onPersistStoreClearKeys}
      onClearAll={onPersistStoreClearAll}
      testID={tID('PersistStore')}
    />
  )
}

interface PersistStoreFormProps {
  persistItems: Dict
  onPersistStoreClearKeys: (values: Dict) => void
  onPersistStoreClearAll: (event: GestureResponderEvent) => void
  persistStoreKeys: Record<string, string>
}
